module.exports = __webpack_public_path__ + "img/sampleCropped.bbfa24d1.jpeg";